































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface, Typography, ArrowWithBorder } from '@/components/atoms';
import DateUtils from '@/utils/DateUtils';

interface IPeriod {
  start: string;
  shortcut: any;
  end: string;
}

@Component({
  components: {
    Surface,
    Typography,
    ArrowWithBorder
  }
})
export default class DateFilter extends Vue {
  @Prop({ required: true }) value!: IPeriod;
  @Prop({ default: false }) right?: boolean;

  get isMobileDevice() {
    return this.$mobileCheck();
  }

  get maxDate() {
    return DateUtils.formattedDate({
      date: new Date(),
      format: 'YYYY-MM-DD'
    });
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get getLabelByPeriod() {
    const { start, end } = this.value;

    const format = (date: string) =>
      DateUtils.formattedDate({
        date,
        applyTimezone: true
      });

    return `${format(start)} - ${format(end)}`;
  }

  get transformedValue() {
    return {
      ...this.value,
      start: DateUtils.formattedDate({
        date: this.value.start,
        applyTimezone: true,
        format: 'YYYY-MM-DD'
      }),
      end: DateUtils.formattedDate({
        date: this.value.end,
        applyTimezone: true,
        format: 'YYYY-MM-DD'
      })
    };
  }

  onCalendarToggle(visibility: string) {
    const el = document.querySelector<HTMLElement>('.container-scrollable');
    if (this.isMobileDevice && el) {
      el.style.overflowY = visibility === 'shown' ? 'hidden' : 'auto';
    }
  }

  onPeriodInput(newValue: IPeriod) {
    if (!newValue.start || !newValue.end) return;

    this.$emit('input', newValue);
  }
}
